<div class="skv-custom-control skv-custom-control--radio" [formGroup]="group">
    <input type="radio" [id]="'radio-button-' + uniqueId" [value]="value" class="skv-custom-control__input" 
        formControlName="control" [checked]="checked" [attr.data-test-id]="value">
    <label class="skv-custom-control__label" [for]="'radio-button-' + uniqueId">
        <ng-content></ng-content>
    </label>
</div>